import { osnovaApi } from '../base';

/** Объявление о технических работах. `active: false` — работ не объявлено. */
export interface MaintenanceStatus {
  active: boolean;
  /** Когда начнётся перезапуск (ISO, UTC). */
  starts_at?: string;
  /** Сколько секунд осталось по часам сервера — на них и опирается отсчёт,
   *  чтобы сбитые часы на клиенте не показывали ерунду. */
  seconds_until?: number;
  /** Свой текст от администратора. Пусто — баннер пишет свой. */
  message?: string | null;
  /** Сколько ожидаем быть недоступными, секунд. */
  expected_duration_sec?: number | null;
}

/** Объявление об обновлении — его ставит деплой перед перезапуском бэкенда
 *  (или администратор руками в «Администрации»). Читается без авторизации:
 *  баннер нужен и на странице входа.
 *
 *  Опрос, а не WebSocket: соединение к моменту перезапуска как раз рвётся, а
 *  объявление должно появиться ЗАРАНЕЕ и независимо от состояния сокета. */
export const maintenanceApi = osnovaApi.injectEndpoints({
  endpoints: (b) => ({
    maintenanceStatus: b.query<MaintenanceStatus, void>({
      query: () => '/maintenance',
      providesTags: ['Maintenance'],
    }),

    /** Объявить работы (админ). `in_seconds` — через сколько перезапуск. */
    announceMaintenance: b.mutation<
      MaintenanceStatus,
      { in_seconds: number; message?: string; expected_duration_sec?: number }
    >({
      query: (body) => ({ url: '/admin/maintenance', method: 'PUT', body }),
      invalidatesTags: ['Maintenance'],
    }),

    /** Снять объявление (админ). */
    cancelMaintenance: b.mutation<{ active: false; removed: boolean }, void>({
      query: () => ({ url: '/admin/maintenance', method: 'DELETE' }),
      invalidatesTags: ['Maintenance'],
    }),
  }),
});

export const {
  useMaintenanceStatusQuery,
  useAnnounceMaintenanceMutation,
  useCancelMaintenanceMutation,
} = maintenanceApi;
